import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Consulta, RequestConsultaReagandarCita } from 'src/core/consulta/consulta.types';
import { RequestConsultaConfirmarCita } from 'src/core/consulta/consulta.types';
import { OkcancelDialogComponent } from '../okcancel-dialog/okcancel-dialog.component';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Router } from '@angular/router';
import { CommonComponent } from '../common-component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { User } from 'src/core/user/user.types';
import { UserService } from 'src/core/user/user.service';
import { EpaycoService } from 'src/app/epayco-payment/epayco.service';
import { EpaycoPaymentComponent } from 'src/app/epayco-payment/epayco-payment.component';
import { EpaycoInterfaceForm } from 'src/core/epayco/epayco.types';


@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent extends CommonComponent implements OnInit {
  ivaPorcentaje : number = 16;
  userSession: User = {} as User;
  @Input('consulta') consulta: Consulta;
  epaycoForm: EpaycoInterfaceForm = {} as EpaycoInterfaceForm;
  now = new Date();
  fechaCita = null;
  validacionCli = false;
  validacionVet = false;
  reAgandarConsulta: RequestConsultaReagandarCita;
  confirmarCita: RequestConsultaConfirmarCita = {
    idCita: 0, // Provide default values or undefined
    correo: '',
    dia: '',
    hora: '',
    nombreUsuarioCliente: '',
    numeroCliente: ''
  }; // Initialize with required properties
  estadoConsulta = {
    1: 'Pendiente por Confirmación', 2: 'Confirmada', 3: 'En Espera de Pago',
    4: 'Rechazada', 5: 'Reprogramada', 6: 'Finalizada', 7: 'Solicitar reagendamiento'
  };
  diasSemana: string[] = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

  constructor(
    public _dialog: MatDialog,
    private _router: Router,
    private _consultaService: ConsultaService,
    private _atencioneService: AtencionService,
    private _userService: UserService,
    _snackBar: MatSnackBar,
    private epaycoService: EpaycoService
  ) {
    super(_snackBar);
  }

  ngOnInit(): void {
    this.reAgandarConsulta = {
      id: 0,
      fechaReagendarCita: '',
      horaReagendarCita: ''
    };

    this.fechaCita = new Date(this.consulta.consultaFechaCita + "T" + this.consulta.consultaHoraCita);
    //console.log("component Appointment fechaCita:", this.fechaCita);
    //this.fechaCita > this.now ? console.log("fecha cita es mayor a la fecha actual"):console.log("fecha cita es menor a la fecha actual") ;
    //console.log(" consulta.consultaReagendar es: ", this.consulta.consultaReagendar);
    this.getUserSession();
  }

  async aceptarReagendamiento() {
    const message = `Confirmar la solicitud de REAGENDAMIENTO para el ${this.consulta.consultaFechaCita} a las ${this.consulta.consultaHoraCita} con un costo de consulta de $ ${this.consulta.consultaCostoConsulta}`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: { message: message }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.reAgandarConsulta.id = this.consulta.consultaId;
        this.reAgandarConsulta.fechaReagendarCita = this.consulta.consultaFechaReagendar;
        this.reAgandarConsulta.horaReagendarCita = this.consulta.consultaHoraReagendar;
        console.log('this.reAgandarConsulta: ', this.reAgandarConsulta);
        this._consultaService.aceptarReagendamiento(this.reAgandarConsulta).subscribe({
          next: (response: Consulta) => {
            const snakREf = this.openSnackBar('Se ha completado exitosamente la programación de la cita.', 20, 'success');
            snakREf.afterDismissed().subscribe(() => {
              this._router.navigate(['/client/home']);
              setTimeout(() => {
                window.location.reload();
              }, 100);
            });

          },
          error: (error: any) => {
            const snakREf = this.openSnackBar('NO se completo el proceso.', 20, 'error');
            console.log('error : ', error);
          }
        });
      }
    });
  }
  solicitarReagendar() {
    this._consultaService.Consulta = this.consulta;
    //this._router.navigateByUrl('/client/schedule-appointment/reschedule');
    this._router.navigate(['/client/schedule-appointment/', 'reschedule'], { queryParams: this.consulta });
  }

  getUserSession() {
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
        this.validarAcciones();
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }
  validarAcciones() {
    /*console.log("validar Acciones");
    console.log(this.userSession.rol);*/

    this.validacionCli = this.userSession.rol === "[ROLE_CLIENTE]" ? true : false;
    this.validacionVet = this.userSession.rol === "[ROLE_SUSCRIPTOR]" ? true : false;
    if (this.validacionVet == this.validacionCli) {
      this.validacionVet = this.validacionCli = false;
    }
    /*console.log("this.validacionCli", this.validacionCli);
    console.log("this.validacionVet", this.validacionVet);*/
  }
  confirm() {
    const message = `Confirmar la cita para el ${this.consulta.consultaFechaCita} a las ${this.consulta.consultaHoraCita} con un costo de consulta de $ ${this.consulta.consultaCostoConsulta}`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: { message: message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.aceptarCita();
      }
    });
  }



  cancel() {
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      data: { message: '¿Está seguro que desea cancelar la cita?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._consultaService.Consulta = this.consulta;
        this.cancelarCita();
      }
    });
  }


  aceptarCita() {
    console.log('consulta select : ', this.consulta);
    console.log('consulta select : ', this.confirmarCitaMapper());
    this._consultaService.aceptarCita(this.confirmarCitaMapper(), this.consulta).subscribe({
      next: (response: any) => {
        this._router.navigateByUrl('vets/appointment-detail');

        /*setTimeout(() => {
          window.location.reload();
        }, 2000);*/
      },
      error: (error: any) => {
        this.openSnackBar(`Error al confirmar cita: ${error.error.status}`);
      }
    });
  }
  cancelarCita() {
    console.log('consulta select : ', this.consulta);
    this._consultaService.cancelarCita(this.consulta).subscribe({
      next: (response: any) => {
        this.openSnackBar(`Cita cancelada`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      error: (error: any) => {
        console.log(JSON.stringify(error));
        this.openSnackBar(`${error}`);
      }
    });
  }

  confirmarCitaMapper() {
    this.confirmarCita.idCita = this.consulta.consultaId;
    this.confirmarCita.correo = this.consulta.correoUsuario;
    this.confirmarCita.dia = this.consulta.consultaFechaCita;
    this.confirmarCita.hora = this.consulta.consultaHoraCita;
    this.confirmarCita.nombreUsuarioCliente = this.consulta.nombreUsuario;
    return this.confirmarCita;
  }
  confirmarPagoMapper() {
    this.confirmarCita.idCita = this.consulta.consultaId;
    this.confirmarCita.correo = this.consulta.suscriptorCorreo;
    this.confirmarCita.dia = this.consulta.consultaFechaCita;
    this.confirmarCita.hora = this.consulta.consultaHoraCita;
    this.confirmarCita.nombreUsuarioCliente = this.consulta.usuarioNombre;
    this.confirmarCita.numeroCliente = this.consulta.usuarioTelefono;
    return this.confirmarCita;
  }

  private setDataEpayco() {    
    this.epaycoForm.name = this.consulta.atencionNombre;
    this.epaycoForm.description = this.consulta.atencionNombre;    
    this.epaycoForm.amount = this.consulta.consultaCostoConsulta.toString();
    // this.epaycoForm.tax_base = this.consulta.atencionNombre;
    // this.epaycoForm.tax = (this.consulta.consultaCostoConsulta * this. ivaPorcentaje).toString();
    // this.epaycoForm.tax_ico = this.consulta.atencionNombre;
    this.epaycoForm.extra1 = this.consulta.consultaId.toString();
    this.epaycoForm.extra2 = this.consulta.nombreUsuario;
    // this.epaycoForm.extra3 = this.consulta.atencionNombre;
    this.epaycoForm.confirmation = this.consulta.atencionNombre;
    this.epaycoForm.response = this.consulta.atencionNombre;
    this.epaycoForm.name_billing = this.consulta.nombreUsuario;
    this.epaycoForm.address_billing = "";
    this.epaycoForm.type_doc_billing = "cc";
    this.epaycoForm.mobilephone_billing = this.consulta.usuarioTelefono;
    this.epaycoForm.number_doc_billing = "";
    this.epaycoForm.email_billing = this.consulta.usuarioCorreo;
  }
  // this.epaycoForm.address_billing = this.consulta.atencionNombre;
  // this.epaycoForm.type_doc_billing = this.consulta.atencionNombre;
  // this.epaycoForm.number_doc_billing = this.consulta.atencionNombre;

  openEpayco(){
    console.log(this.consulta);    
    this.setDataEpayco();
    console.log(this.epaycoForm);
    
    const dialogRef = this._dialog.open(EpaycoPaymentComponent, {
      data: {
         epaycoForm: this.epaycoForm
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
    });
  }

  confirmPayment() {
    
    /*
    console.log('Pagar cita');*/

    const message = `Pagar la cita para el ${this.consulta.consultaFechaCita} a las ${this.consulta.consultaHoraCita} con un costo de consulta de $ ${this.consulta.consultaCostoConsulta}`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: { message: message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        
        console.log('Pasar a pagar:', this.consulta);
        console.log('Data: ', this.confirmarPagoMapper());
        this.openEpayco();
        /*this._consultaService.confirmarPago(this.confirmarPagoMapper(), this.consulta).subscribe({
          next: (response: any) => {
            window.location.reload();
            console.log('RECARGA!');
            
          },
          error: (error: any) => {
            console.log("_------------------");
            console.log(error);
            
            
            this.openSnackBar(`Error al confirmar cita: ${error.error.status}`);
          }
        });*/

      }
    });
  }

}
